// Create a file named ResourceLimitModal.jsx in the components directory

import React, { useState } from 'react';
import { AlertCircle, X, Crown } from 'lucide-react';
import SubscriptionModal from './SubscriptionModal';

const ResourceLimitModal = ({ 
  user, 
  message,
  resourceType,
  onClose,
  onUpgrade
}) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1e293b] rounded-xl shadow-xl max-w-md w-full p-6 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          <X className="h-5 w-5" />
        </button>
        
        <div className="flex items-center mb-4">
          <AlertCircle className="h-8 w-8 text-red-500 mr-3" />
          <h3 className="text-xl font-bold text-white">Resource Limit Reached</h3>
        </div>
        
        <p className="text-gray-300 mb-6">
          {message || 'You have used all your available resources for this billing period.'}
        </p>
        
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            Close
          </button>
          
          <button
            onClick={() => setShowUpgradeModal(true)}
            className="px-4 py-2 bg-[#ff7e00] hover:bg-[#e86e00] text-white rounded-lg transition-colors flex items-center"
          >
            <Crown className="h-4 w-4 mr-2" />
            Upgrade Plan
          </button>
        </div>
        
        {showUpgradeModal && (
          <SubscriptionModal
            isOpen={showUpgradeModal}
            onClose={() => setShowUpgradeModal(false)}
            user={user}
            appId="saleswit"
          />
        )}
      </div>
    </div>
  );
};

export default ResourceLimitModal;